import { DEFAULT_PLANNER_CONFIG, rankearAtividadesPorAvaliacao } from './planner.js';
import { normalizeNeed } from './utils.js';
import { normalizarHabilidadeId } from './skillAliases.js';

export const DEFAULT_RECOMMENDER_OPTIONS = {
  limiarDeficit: 60,
  topN: 8,
  filtros: {},
};

function normalizarLista(values = []) {
  return (Array.isArray(values) ? values : [values]).map(normalizeNeed).filter(Boolean);
}

export function atividadeAtendeFiltros(atividade, filtros = {}) {
  const busca = normalizeNeed(filtros.busca || '');
  const texto = normalizeNeed(`${atividade.titulo} ${atividade.objetivo} ${(atividade.funcoes || []).join(' ')} ${(atividade.habilidades_alvo || []).join(' ')} ${(atividade.necessidades_indicadas || []).join(' ')}`);
  const necessidades = normalizarLista(atividade.necessidades_indicadas || []);
  const funcoes = normalizarLista(atividade.funcoes || []);
  const habilidade = filtros.habilidade ? normalizarHabilidadeId(filtros.habilidade) : '';
  const dificuldade = Number(filtros.dificuldade || 0);
  if (busca && !texto.includes(busca)) return false;
  if (filtros.eixo && atividade.eixo !== filtros.eixo) return false;
  if (habilidade && !(atividade.habilidades_alvo || []).map(normalizarHabilidadeId).includes(habilidade)) return false;
  if (filtros.necessidade && !necessidades.includes(normalizeNeed(filtros.necessidade))) return false;
  if (filtros.funcao && !funcoes.includes(normalizeNeed(filtros.funcao))) return false;
  if (dificuldade && Number(atividade.nivel_dificuldade || 0) !== dificuldade) return false;
  return true;
}

export function identificarDeficits(avaliacao = {}, limiar = DEFAULT_RECOMMENDER_OPTIONS.limiarDeficit) {
  const pontuacoes = avaliacao.pontuacoes || avaliacao.habilidades || avaliacao;
  return Object.entries(pontuacoes)
    .map(([habilidadeId, score]) => ({ habilidadeId: normalizarHabilidadeId(habilidadeId), score }))
    .filter((item) => typeof item.score === 'number' && item.score < limiar)
    .map((item) => ({ ...item, pesoDeficit: Math.max(0, limiar - item.score) }))
    .sort((a, b) => b.pesoDeficit - a.pesoDeficit);
}

export function recomendarAtividades(avaliacao = {}, perfil = {}, bancoAtividades, options = {}) {
  const cfg = { ...DEFAULT_RECOMMENDER_OPTIONS, ...options, filtros: { ...(options.filtros || {}) } };
  return rankearAtividadesPorAvaliacao({
    avaliacao,
    aluno: perfil,
    bancoAtividades: bancoAtividades?.atividades || bancoAtividades || [],
    logs: options.logs || [],
    metasPEI: options.metasPEI || [],
    caseStudy: options.caseStudy || {},
    filtros: cfg.filtros,
    topN: cfg.topN,
    config: { ...DEFAULT_PLANNER_CONFIG, deficitThreshold: cfg.limiarDeficit },
  });
}

export function filtrarAtividades(bancoAtividades, filtros = {}) {
  return (bancoAtividades?.atividades || [])
    .filter((atividade) => atividadeAtendeFiltros(atividade, filtros))
    .sort((a, b) => a.eixo.localeCompare(b.eixo, 'pt-BR') || a.titulo.localeCompare(b.titulo, 'pt-BR'));
}
